"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_DEFAULT = exports.TYPE_MOBILE = exports.TYPE_DESKTOP = void 0;
exports.TYPE_DESKTOP = 0;
exports.TYPE_MOBILE = 1;
exports.TYPE_DEFAULT = Infinity;
//# sourceMappingURL=types.js.map